import { blackBase, contrast, whiteBase } from '@mentimeter/ragnar-colors';
import Color from 'color';

const GRAYS = ['#424242', '#545454', '#7a7a7a', '#939393', '#a9a9a9'];
const STEPS = [0.35, 0.7];

export const getTextColors = (colors: string[]) =>
  colors.map((color) => {
    const contrastToWhite = contrast(color, whiteBase);
    if (contrastToWhite > 4.5) {
      return whiteBase;
    } else {
      return blackBase;
    }
  });

const hasEnoughContrast =
  (contrastColorReference: string) => (color: string) => {
    const contrast = Color(color).contrast(Color(contrastColorReference));

    if (contrast < 1.2) {
      return false;
    }
    return true;
  };

export const getBarColors = (colors: string[], contrastColor = '#ffffff') => {
  const brighterColors = STEPS.flatMap((step) =>
    colors.map((color) =>
      Color(color).mix(Color('white'), step).hex().toString(),
    ),
  ).filter(hasEnoughContrast(contrastColor));

  return colors.concat(brighterColors).concat(GRAYS);
};

export const getColors = (
  themeBarColors: string[],
  backgroundColor = '#ffffff',
) => {
  const barColors = getBarColors(themeBarColors, backgroundColor);
  const textColors = getTextColors(barColors);
  return {
    textColors,
    barColors,
  };
};
